import pattern from 'patternomaly'
const patternSize = 10

const seizureColor = {
    seizureA: '#97C66B',
    seizureB: '#FFC727',
    seizureC: '#FA8D8D',
    seizureD: '#61CFE9',
    seizureE: '#AC85D4',
    seizureF: '#FF89C0',
    seizureOther: '#E0E0E0',
}

const defaultDatasets = [
    {
      index: 0,
      backgroundColor: pattern.draw('line-vertical', seizureColor.seizureA, undefined, patternSize),
      borderColor: seizureColor.seizureA,
      categoryPercentage: 0.9,
      barPercentage: 0.6,
      data: []
    },
    {
      index: 1,
      backgroundColor: pattern.draw('line', seizureColor.seizureB, undefined, patternSize),
      borderColor: seizureColor.seizureB,
      categoryPercentage: 0.9,
      barPercentage: 0.6,
      data: []
    },
    {
      index: 2,
      backgroundColor: pattern.draw('square', seizureColor.seizureC, undefined, patternSize),
      borderColor: seizureColor.seizureC,
      categoryPercentage: 0.9,
      barPercentage: 0.6,
      data: []
    },
    {
      index: 3,
      backgroundColor: pattern.draw('diagonal', seizureColor.seizureD, undefined, patternSize),
      borderColor: seizureColor.seizureD,
      categoryPercentage: 0.9,
      barPercentage: 0.6,
      data: []
    },
    {
      index: 4,
      backgroundColor: pattern.draw('cross', seizureColor.seizureE, undefined, patternSize),
      borderColor: seizureColor.seizureE,
      categoryPercentage: 0.9,
      barPercentage: 0.6,
      data: []
    },
    {
      index: 5,
      backgroundColor: seizureColor.seizureF,
      borderColor: seizureColor.seizureF,
      categoryPercentage: 0.9,
      barPercentage: 0.6,
      data: []
    },
    {
      index: 6,
      backgroundColor: pattern.draw('box', seizureColor.seizureOther, undefined, patternSize),
      borderColor: seizureColor.seizureE,
      categoryPercentage: 0.9,
      barPercentage: 0.6,
      data: []
    }
  ]

const otherPattern = pattern.draw('box', seizureColor.seizureOther, undefined, patternSize)

export { seizureColor, defaultDatasets, otherPattern }